import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'
import { formatDateLong } from '../../utils/date'

const SowTerminateedModal = ({ showModal, handleClose, terminatedData }) => {
  const modalClose = () => {
    handleClose()
  }
  const formattedDate = terminatedData?.terminatedOn
    ? formatDateLong(terminatedData.terminatedOn) // "May 28, 2025"
    : ''

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className='payment-modal'>
        <Modal.Header className='payment-modal-header d-flex justify-content-center'>
          <h3 className='payment-modal-title mb-0'>
            Session Notice / SOW Terminated{' '}
          </h3>
        </Modal.Header>
        <Modal.Body className='payment-modal-body'>
          <>
            <p className='pt-2'>
              This SOW was terminated on <strong>{formattedDate}</strong>, but
              there are still{' '}
              <strong>{terminatedData?.remainingSession}</strong> remaining
              sessions in the plan. Please contact the administrator for further
              assistance.{' '}
            </p>
          </>
        </Modal.Body>
        <Modal.Footer className='border-0 d-flex justify-content-end pt-0'>
          <Button
            variant='secondary-light'
            onClick={modalClose}
            className='px-3 secondary-popup-button'
            size='sm'>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SowTerminateedModal
